import "./index.scss";
import classNames from "classnames";
import { useEffect } from "react";
import { createPortal } from "react-dom";

interface MaskProps {
  visible: boolean;
  className?: string;
  children: React.ReactNode;
  onCancel?: () => void;
}

export default ({ visible, className, children, onCancel }: MaskProps) => {
  useEffect(() => {
    const $html = document.body.parentElement;
    if ($html && visible) {
      $html.style.overflow = "hidden";
    }
    return () => {
      if ($html) {
        $html.style.overflow = "overlay";
      }
    };
  }, [visible]);

  if (visible) {
    return (
      <>
        {createPortal(
          <div
            className={classNames("Component-Mask", className)}
            onClick={() => {
              onCancel && onCancel();
            }}
          >
            {children}
          </div>,
          document.body,
        )}
      </>
    );
  }
  return null;
};
